import React, { useEffect, useState } from "react";
import "./index.scss";
import SidePanel from "../../SidePanel";
import Select from "react-select";
import { Form } from "react-bootstrap";
import { MdAccessTime } from "react-icons/md";
import { Container, Row, Col } from "react-bootstrap";
import DonutChart from "./DounutChart";
import LineChart from "./LineChart";
import BarChart from "./BarChart";
import viewDetailsIcon from "./../../../Assets/icons/viewDetails.svg";
import revenueIcon from "./../../../Assets/images/DashboardRevenue.png";
import serviceReportIcon from "./../../../Assets/images/ServiceReportIcon.png";
import inventoryIcon from "./../../../Assets/images/InventoryReport.png";
import totalLeadIcon from "./../../../Assets/icons/TotalLeads.svg";
import totalProductsIcon from "./../../../Assets/icons/TotalProducts.svg";
import arrowUpIcon from "./../../../Assets/icons/arrow-up 1.svg";
import axiosInstance from "../../../http.common";
import Loader from "../../customComponents/CustomLoader";
import AdminAreaChart from "./AreaChart/AreaChart";
import AdminDonutChart from "./DonutChartAdmin/AdminDonutChart";
import ApexColumnChart from "./ApexCharts/ApexCharts";
import { useNavigate } from "react-router-dom";
import ROUTES_NAVIGATION from "../../../routes/routes";

const Dashboard = ({ card_id }) => {
  const businessPartnerId = localStorage.getItem("business_partner_id");
  const authToken = localStorage.getItem("authToken");

  const navigate = useNavigate();

  const navigateOrderManagement = () => {
    navigate(ROUTES_NAVIGATION.ORDERMANAGEMENTLIST);
  };

  const navigateToVariant = () => {
    navigate("/admin/manage-product/variant");
  };

  const navigateToService = () => {
    navigate("/manage-services/check-warranty");
  };
  const [selectedDealerId, setSelectedDealerId] = useState(null);
  const [selectedSalesPersonId, setSelectedSalesPersonId] = useState(null);
  const [selectedSalesPerson, setSelectedSalesPerson] = useState(null);

  const [loading, setLoading] = useState(true);
  const [year, setYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedBusinessPartner, setSelectedBusinessPartner] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedDealer, setSelectedDealer] = useState("");

  const [leadDetailsVal, setLeadDetailsVal] = useState([]);
  const [logisticsdetailVal, setLogisticsDetailVal] = useState([]);
  const [variantdetailVal, setVariantDetailVal] = useState([]);
  const [serviceDetailsVal, setServiceDetailsVal] = useState([]);
  const [topbarDetailsVal, setTopbarDetailsVal] = useState([]);
  const [activeFilter, setActiveFilter] = useState("last24Hours");
  const [LineChartData, setLineChartData] = useState({});
  const [PieChartData, setPieChartData] = useState([]);
  const [serviceChart, setServiceCharts] = useState({});

  const [dealerDd, setDealerdd] = useState([]);
  const [salesPersonDd, setSalesPersondd] = useState([]);

  const [firstRowDetails, setFirstRowDetails] = useState(null);
  const [secondRightRow, setSecondRightRow] = useState({});

  const [secondRightBoxValue, setSecondRightBoxValue] = useState({});

  const [revenueVal, setRevenueVal] = useState();
  const [salesVal, setSalesVal] = useState();

  const [userTypedd, setUserTypedd] = useState([]);

  // useEffect(() => {
  //   // This will trigger fetch on first load too
  //   const currentDate = new Date();
  //   const fromDate = new Date(currentDate.getTime() - 24 * 60 * 60 * 1000)
  //     .toISOString()
  //     .split("T")[0];
  //   const toDate = currentDate.toISOString().split("T")[0];

  //   fetchAdminDetails({ fromDate, toDate });
  //   fetchTotalRevenue({ fromDate, toDate });
  //   fetchTotalSales({ fromDate, toDate });
  //   fetchPieChartVal({ fromDate, toDate });
  //   fetchAreaChartVal({ fromDate, toDate });
  // }, []);

  // useEffect(() => {
  //   // fetchAdminDetails(getCurrentMonthDateRange());
  //   fetchTotalRevenue(getCurrentMonthDateRange);
  //   fetchTotalSales(getCurrentMonthDateRange);
  //   fetchPieChartVal(getCurrentMonthDateRange);
  //   // fetchAreaChartVal(getCurrentMonthDateRange)
  // }, []);

  useEffect(() => {
    const initialPayload = {
      fromDate,
      toDate,
      dealerId: selectedDealerId,
      salesPersonId: selectedSalesPersonId,
    };

    fetchAdminDetails(initialPayload);
    fetchTotalRevenue(initialPayload);
    fetchTotalSales(initialPayload);
    fetchPieChartVal(initialPayload);
    fetchAreaChartVal(initialPayload);
  }, []);

  // const currentDate = new Date();
  // const formattedDate = currentDate.toISOString().split('T')[0];

  const currentDate = new Date();
 const formattedDate = currentDate.toISOString().split("T")[0]; // 'YYYY-MM-DD'
  
  const formattedToday = currentDate.toISOString().split("T")[0];

  const yesterday = new Date(currentDate);
  yesterday.setDate(currentDate.getDate() - 1);
  const formattedYesterday = yesterday.toISOString().split("T")[0];

  const [fromDate, setFromDate] = useState(formattedYesterday);
  const [toDate, setToDate] = useState(formattedToday);


  // Function to get date range for the current month
  const getCurrentMonthDateRange = () => {
    const currentDate = new Date();
    const firstDayOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1,
    );
    const lastDayOfMonth = new Date(currentDate);
    return {
      fromDate: firstDayOfMonth.toISOString().split("T")[0],
      toDate: lastDayOfMonth.toISOString().split("T")[0],
    };
  };

  const fetchTotalSales = async ({
    fromDate,
    toDate,
    dealerId,
    salesPersonId,
  }) => {
    try {
      const finalFromDate = fromDate || formattedYesterday;
  const finalToDate = toDate || formattedToday;

      const response = await axiosInstance.post(
        "/admin/admin-dashboard-selles",
        {
          // dealerId: 1,
          // dealerId: dealerId || "",
          dealerId: dealerId ? String(dealerId) : "",
          fromDate: fromDate || finalFromDate,
          toDate: toDate || finalToDate,
          vehicleId: "",
          salesYear: "",
          serviceType: "",
          salesPersonId: salesPersonId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const fetchedData = response.data?.data?.totalSalesAmount;
      console.log(fetchedData, "DashboardDetailsRevenue");
      setSalesVal(fetchedData);
    } catch (error) {
      console.error("Error fetching admin list:", error);
    }
  };

  const fetchTotalRevenue = async ({
    fromDate,
    toDate,
    dealerId,
    salesPersonId,
  }) => {
    try {
const finalFromDate = fromDate || formattedYesterday;
  const finalToDate = toDate || formattedToday;

      const response = await axiosInstance.post(
        "/admin/admin-dashboard-revenue",
        {
          // dealerId: 1,
          // dealerId: dealerId || "",
          dealerId: dealerId ? String(dealerId) : "",
          // fromDate: fromDate || currentDate,
          // toDate: toDate,
          fromDate: fromDate || finalFromDate,
          toDate: toDate || finalToDate,
          vehicleId: "",
          salesYear: "",
          serviceType: "",
          salesPersonId: salesPersonId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const fetchedData = response.data?.data?.totalRevenueAmount;
      console.log(fetchedData, "DashboardDetailsRevenue");
      setRevenueVal(fetchedData);
    } catch (error) {
      console.error("Error fetching admin list:", error);
    }
  };

  // const fetchPieChartVal = async ({ fromDate, toDate, dealerId }) => {
  //   try {
  //     const response = await axiosInstance.post(
  //       "/admin/admin-dashboard-states",
  //       {
  //         // dealerId: 1,
  //         dealerId: dealerId || null,
  //         fromDate: fromDate || currentDate,
  //         toDate,
  //         vehicleId: "",
  //         salesYear: "",
  //         serviceType: "",
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${authToken}`,
  //         },
  //       }
  //     );

  //     const fetchedData = response.data?.data?.stateWisePaiChartData;
  //     console.log(fetchedData, "DashboardDetailsRevenue");
  //     setPieChartData(fetchedData)
  //   } catch (error) {
  //     console.error("Error fetching admin list:", error);
  //   }
  // };

  const fetchAreaChartVal = async ({
    fromDate,
    toDate,
    dealerId,
    salesPersonId,
  }) => {
    try {
      const response = await axiosInstance.post(
        "/admin/admin-dashboard-monthly-sales",
        {
          // dealerId: dealerId || "",
          dealerId: dealerId ? String(dealerId) : "",
          fromDate: fromDate || currentDate,
          toDate: toDate,
          vehicleId: "",
          salesYear: "",
          serviceType: "",
          salesPersonId: salesPersonId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const fetchedData = response.data?.data?.graphSalesOverView || {};
      console.log(fetchedData, "DashboardDetailsAreaChart");
      setLineChartData(fetchedData);
    } catch (error) {
      console.error("Error fetching admin list:", error);
      setLineChartData([]); // fallback on error
    }
  };

  const fetchPieChartVal = async ({
    fromDate,
    toDate,
    dealerId,
    salesPersonId,
  }) => {
    try {
      const response = await axiosInstance.post(
        "/admin/admin-dashboard-states",
        {
          // dealerId: dealerId || "",
          dealerId: dealerId ? String(dealerId) : "",
          fromDate: fromDate || currentDate,
          toDate: toDate,
          vehicleId: "",
          salesYear: "",
          serviceType: "",
          salesPersonId: salesPersonId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const fetchedData = response.data?.data?.stateWisePaiChartData || {};
      console.log(fetchedData, "DashboardDetailsRevenue");
      setPieChartData(fetchedData);
    } catch (error) {
      console.error("Error fetching admin list:", error);
      setPieChartData([]); // fallback on error
    }
  };

  const fetchAdminDetails = async ({
    fromDate,
    toDate,
    dealerId,
    salesPersonId,
  }) => {
    try {
      const response = await axiosInstance.post(
        "/admin/admin-dashboard",
        {
          // dealerId: 1,
          // dealer_id: dealerId || "",
          dealerId: dealerId ? String(dealerId) : "",
          fromDate: fromDate || currentDate,
          toDate: toDate,
          vehicleId: "",
          salesYear: "",
          serviceType: "",
          salesPersonId: salesPersonId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const fetchedData = response.data.data;
      console.log(fetchedData, "DashboardDetails");

      const firstRowDetails = fetchedData?.firstRow;
      setFirstRowDetails(firstRowDetails);

      const secondRowFirstSection = fetchedData?.secondrightRow?.firstSection;
      setSecondRightRow(secondRowFirstSection);
      console.log(secondRowFirstSection, "secondRowFIRSTSECTION");

      const secondrightbox = fetchedData?.secondrightRow?.secondrightbox;
      setSecondRightBoxValue(secondrightbox);

      const graphSalesOverView = fetchedData?.graphSalesOverView;
      const servicesChart = fetchedData?.servicesChart;

      // setLineChartData(graphSalesOverView);
      // setPieChartData(stateWisePaiChartData);
      setServiceCharts(servicesChart);
    } catch (error) {
      console.error("Error fetching admin list:", error);
    }
  };

  // const handleDateRangeClick = (range) => {
  //   let fromDate, toDate;

  //   switch (range) {
  //     case "last24Hours":
  //       fromDate = new Date(currentDate.getTime() - 24 * 60 * 60 * 1000)
  //         .toISOString()
  //         .split("T")[0];
  //       toDate = currentDate.toISOString().split("T")[0];
  //       break;
  //     case "lastWeek":
  //       fromDate = new Date(currentDate.getTime() - 7 * 24 * 60 * 60 * 1000)
  //         .toISOString()
  //         .split("T")[0];
  //       toDate = currentDate.toISOString().split("T")[0];
  //       break;
  //     case "lastMonth":
  //       const lastMonthDate = new Date(
  //         currentDate.getFullYear(),
  //         currentDate.getMonth() - 1,
  //         1
  //       );
  //       fromDate = new Date(
  //         lastMonthDate.getFullYear(),
  //         lastMonthDate.getMonth(),
  //         1
  //       )
  //         .toISOString()
  //         .split("T")[0];
  //       toDate = new Date(
  //         lastMonthDate.getFullYear(),
  //         lastMonthDate.getMonth() + 1,
  //         0
  //       )
  //         .toISOString()
  //         .split("T")[0];
  //       break;
  //     case "lastYear":
  //       fromDate = new Date(currentDate.getFullYear() - 1, 0, 1)
  //         .toISOString()
  //         .split("T")[0];
  //       toDate = new Date(currentDate.getFullYear() - 1, 11, 31)
  //         .toISOString()
  //         .split("T")[0];
  //       break;
  //     default:
  //       return;
  //   }

  //   setActiveFilter(range);

  //   const payload = { fromDate, toDate, dealerId: selectedDealerId };

  //   fetchAdminDetails(payload);
  //   fetchTotalRevenue(payload);
  //   fetchTotalSales(payload);
  //   fetchPieChartVal(payload);
  //   fetchAreaChartVal(payload);
  // };

  // const handleDateRangeClick = (range) => {
  //   const now = new Date();
  //   let newFromDate, newToDate;

  //   switch (range) {
  //     case "last24Hours":
  //       newFromDate = new Date(now.getTime() - 24 * 60 * 60 * 1000)
  //         .toISOString()
  //         .split("T")[0];
  //       newToDate = now.toISOString().split("T")[0];
  //       break;

  //     case "lastWeek":
  //       newFromDate = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000)
  //         .toISOString()
  //         .split("T")[0];
  //       newToDate = now.toISOString().split("T")[0];
  //       break;

  //     case "lastMonth": {
  //       const lastMonthDate = new Date(
  //         now.getFullYear(),
  //         now.getMonth() - 1,
  //         1
  //       );
  //       newFromDate = new Date(
  //         lastMonthDate.getFullYear(),
  //         lastMonthDate.getMonth(),
  //         1
  //       )
  //         .toISOString()
  //         .split("T")[0];
  //       newToDate = new Date(
  //         lastMonthDate.getFullYear(),
  //         lastMonthDate.getMonth() + 1,
  //         0
  //       )
  //         .toISOString()
  //         .split("T")[0];
  //       break;
  //     }

  //     case "lastYear":
  //       newFromDate = new Date(now.getFullYear() - 1, 0, 1)
  //         .toISOString()
  //         .split("T")[0];
  //       newToDate = new Date(now.getFullYear() - 1, 11, 31)
  //         .toISOString()
  //         .split("T")[0];
  //       break;

  //     default:
  //       return;
  //   }

  //   // update active filter + date state
  //   setActiveFilter(range);
  //   setFromDate(newFromDate);
  //   setToDate(newToDate);

  //   // Build payload using the currently selected dealer/sales person
  //   const payload = {
  //     fromDate: newFromDate,
  //     toDate: newToDate,
  //     dealerId: selectedDealerId,
  //     salesPersonId: selectedSalesPersonId,
  //   };

  //   fetchAdminDetails(payload);
  //   fetchTotalRevenue(payload);
  //   fetchTotalSales(payload);
  //   fetchPieChartVal(payload);
  //   fetchAreaChartVal(payload);
  // };

  const formatDate = (date) => {
    // Returns YYYY-MM-DD in local time (safe for backend)
    return date.toLocaleDateString("en-CA");
  };

  const handleDateRangeClick = (range) => {
    const now = new Date();
    let newFromDate, newToDate;

    switch (range) {
      case "last24Hours": {
        const from = new Date(now);
        from.setHours(now.getHours() - 24);

        newFromDate = formatDate(from);
        newToDate = formatDate(now);
        break;
      }

      case "lastWeek": {
        const today = new Date();

        // Convert JS Sunday=0 → ISO Monday=0
        const dayOfWeek = (today.getDay() + 6) % 7;

        // Previous week's Monday
        const lastWeekStart = new Date(today);
        lastWeekStart.setDate(today.getDate() - dayOfWeek - 7);

        // Previous week's Sunday
        const lastWeekEnd = new Date(lastWeekStart);
        lastWeekEnd.setDate(lastWeekStart.getDate() + 6);

        newFromDate = formatDate(lastWeekStart);
        newToDate = formatDate(lastWeekEnd);
        break;
      }

      case "lastMonth": {
        const lastMonthStart = new Date(
          now.getFullYear(),
          now.getMonth() - 1,
          1,
        );

        const lastMonthEnd = new Date(now.getFullYear(), now.getMonth(), 0);

        newFromDate = formatDate(lastMonthStart);
        newToDate = formatDate(lastMonthEnd);
        break;
      }

      case "lastYear": {
        const lastYearStart = new Date(now.getFullYear() - 1, 0, 1);
        const lastYearEnd = new Date(now.getFullYear() - 1, 11, 31);

        newFromDate = formatDate(lastYearStart);
        newToDate = formatDate(lastYearEnd);
        break;
      }

      default:
        return;
    }

    // Update UI state
    setActiveFilter(range);
    setFromDate(newFromDate);
    setToDate(newToDate);

    // API payload
    const payload = {
      fromDate: newFromDate,
      toDate: newToDate,
      dealerId: selectedDealerId,
      salesPersonId: selectedSalesPersonId,
    };

    fetchAdminDetails(payload);
    fetchTotalRevenue(payload);
    fetchTotalSales(payload);
    fetchPieChartVal(payload);
    fetchAreaChartVal(payload);
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      border: "1px solid 7BD755",
      boxShadow: "none",
      borderRadius: "20px",
      backgroundColor: "#fff",
      color: "#7BD755",
      width: "200px",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#7BD755",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#7BD755",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#7BD755",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "4px",
    }),
    menuList: (provided) => ({
      ...provided,
      padding: 0,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "7BD755" : provided.backgroundColor,
      color: state.isFocused ? "black" : "#000",
    }),
  };

  // useEffect(() => {
  //   userTypedropdown();
  // }, []);
  useEffect(() => {
    Dealerdropdown();
  }, []);

  const Dealerdropdown = async (salesPersonId) => {
    const payload = { salesPersonId: salesPersonId || "" };

    try {
      const response = await axiosInstance.post(
        "/dealer/ddlDealerDash",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const data = response?.data?.data?.data;
      const userTypeOptions = data?.map((user) => ({
        value: user.dealer_id,
        label: user.dealer_name,
      }));
      setDealerdd(userTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    SalesPersondropdown();
  }, []);

  const SalesPersondropdown = async (id) => {
    try {
      const response = await axiosInstance.get(
        "/salesperson/ddlSalesperson",
        // { business_partner_id: 1 },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const data = response.data.data;
      const userTypeOptions = data.map((user) => ({
        value: user.sales_person_id,
        label: user.sales_person_name,
      }));
      setSalesPersondd(userTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };

  // setSalesPersondd

  // const userTypedropdown = async () => {
  //   try {
  //     const response = await axiosInstance.get("/bp-onboard/bplist", {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${authToken}`,
  //       },
  //     });

  //     const data = response.data.data.data;
  //     const userTypeOptions = data.map((user) => ({
  //       value: user.onboard_id,
  //       label: user.bp_name,
  //     }));
  //     setUserTypedd(userTypeOptions);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // const handleBusinessPartnerChange = (selectedOption) => {
  //   const selectedDealerId = selectedOption?.value || 0; // Get the selected dealer ID
  //   fetchAdminDetails({
  //     // fromDate: currentDate,
  //     // toDate: currentDate,
  //     // dealerId: selectedDealerId,
  //     fromDate: formattedDate,
  //   toDate: formattedDate,
  //   dealerId: selectedDealerId,
  //   });
  // };

  const handleBusinessPartnerChange = (selectedOption) => {
    // const dealerId = selectedOption?.value || null;
    // setSelectedDealerId(dealerId);
    const dealerId = selectedOption?.value || null;
    setSelectedDealerId(dealerId);

    const salesPersonId = selectedOption?.value || null;
    setSelectedSalesPersonId(salesPersonId);

    const payload = {
      fromDate,
      toDate,
      dealerId,
      salesPersonId,
    };

    fetchAdminDetails(payload);
    fetchTotalRevenue(payload);
    fetchTotalSales(payload);
    fetchPieChartVal(payload);
    fetchAreaChartVal(payload);

    // fetchAdminDetails({
    //   fromDate: formattedDate,
    //   toDate: formattedDate,
    //   dealerId: dealerId,
    //   salesPersonId: salesPersonId,
    // });

    // fetchTotalRevenue({
    //   fromDate: formattedDate,
    //   toDate: formattedDate,
    //   dealerId: dealerId,
    //   salesPersonId: salesPersonId,
    // });

    // fetchTotalSales({
    //   fromDate: formattedDate,
    //   toDate: formattedDate,
    //   dealerId: dealerId,
    //   salesPersonId: salesPersonId,
    // });

    // fetchPieChartVal({
    //   fromDate: formattedDate,
    //   toDate: formattedDate,
    //   dealerId: dealerId,
    //   salesPersonId: salesPersonId,
    // });

    // fetchAreaChartVal({
    //   fromDate: formattedDate,
    //   toDate: formattedDate,
    //   dealerId: dealerId,
    //   salesPersonId: salesPersonId,
    // });
  };

  // useEffect(() => {
  //   fetchDashboardData()
  // },[])

  // Dashboard Api Fetching
  // const fetchDashboardData = async () => {
  //   const currentDate = new Date();
  //   const currentYear = currentDate.getFullYear();
  //   const currentMonth = currentDate.getMonth() + 1;

  //   try {
  //     // setLoading(true);
  //     const response = await axiosInstance.post(
  //       `/logistic/dashboard-details`,
  //       {
  //         year: year || currentYear,
  //         month: selectedMonth?.value || null,
  //         business_partner_id: selectedBusinessPartner?.value,
  //         searchText: searchQuery,
  //         dealer_id: selectedDealer?.value,
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${authToken}`,
  //         },
  //       }
  //     );

  //     const fetchedData = response?.data?.data?.tabledata;
  //     const fetchedGraphData = response?.data?.data?.graphdata;
  //     const fetchedPieData = response?.data?.data?.piedata;
  //     const fetchedDataCount = response?.data?.data?.countdetail[0];
  //     // setTotalPercentCount(fetchedDataCount)
  //     console.log("totalPercentCount",fetchedDataCount?.total_po_percentage_change);

  //     // setTotalPO(fetchedDataCount?.total_po);
  //     // setCancelPO(fetchedDataCount?.cancel_po);
  //     // setCompletedPO(fetchedDataCount?.completed_po);
  //     // setoutofstokPO(fetchedDataCount?.outofstock);
  //     // setPendingPO(fetchedDataCount?.pending_po);

  //     // setProductData(fetchedData);
  //     // setLineChartData(fetchedGraphData);
  //     // setPieChartData(fetchedPieData);
  //   } catch (error) {
  //     console.error(error);
  //   } finally {
  //     // setLoading(false); // End loading
  //   }
  // };

  return (
    <div className="dashboard-container">
      {/* <SidePanel card_id={card_id} /> */}
      {/* <SidebarDrawer /> */}
      <div className="">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          className="filters-container"
        >
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            <div style={{ display: "none", alignItems: "center", gap: "10px" }}>
              <span>Select Sales Person</span>
              <Form.Group controlId="formMonth" className="filter-dropdown">
                {/* <Select
                  isClearable
                  styles={customStyles}
                  options={salesPersonDd}
                  onChange={handleSalesPersonChange}
                  placeholder="Select Sales Person"
                /> */}
              </Form.Group>
            </div>
            {/* dealer wise filter */}
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <span>Select Dealer</span>
              <Form.Group controlId="formMonth" className="filter-dropdown">
                {/* <Select
                  isClearable
                  styles={customStyles}
                  options={dealerDd}
                  onChange={handleBusinessPartnerChange}
                  placeholder="Select Dealer"
                /> */}
                <Select
                  isClearable
                  styles={customStyles}
                  options={dealerDd}
                  onChange={handleBusinessPartnerChange}
                  placeholder="Select Dealer"
                />
              </Form.Group>
            </div>
          </div>
          {/* day and year wise filter */}
          <div className="filter-buttons">
            <button
              style={{ borderRadius: "24px" }}
              className={`filter-button ${
                activeFilter === "last24Hours" ? " active" : ""
              }`}
              onClick={() => handleDateRangeClick("last24Hours")}
            >
              24 Hours
            </button>
            <button
              style={{ borderRadius: "24px" }}
              className={`filter-button ${
                activeFilter === "lastWeek" ? "active" : ""
              }`}
              onClick={() => handleDateRangeClick("lastWeek")}
            >
              Last Week
            </button>
            <button
              style={{ borderRadius: "24px" }}
              className={`filter-button ${
                activeFilter === "lastMonth" ? "active" : ""
              }`}
              onClick={() => handleDateRangeClick("lastMonth")}
            >
              Last Month
            </button>
            <button
              style={{ borderRadius: "24px" }}
              className={`filter-button ${
                activeFilter === "lastYear" ? "active" : ""
              }`}
              onClick={() => handleDateRangeClick("lastYear")}
            >
              Last Year
            </button>
            <span className="date-range-dashboard">
              <MdAccessTime className="icon" />
              <span className="text">
                {fromDate} <span className="separator">to</span> {toDate}
              </span>
            </span>
          </div>
        </div>
        <div className="mainCardsContainer">
          <div className="maintotalleadscontainer">
            <div className="maintotalsContainers">
              <div className="totalrevenuetitle">
                <div className="maintotalicons">
                  <img src={revenueIcon} />
                </div>
                <h5 className="mt-2">Total Revenue</h5>
              </div>

              <span className="viewdetails">
                {/* <img className="viewimage" src={viewDetailsIcon} /> */}
              </span>
            </div>
            <div className="AmountContaner mt-3">
              <h3 style={{ fontWeight: "600" }} className="total">
                {revenueVal || 0}{" "}
              </h3>
              <div>
                <div className="profitContainer">
                  {/* <img src={arrowUpIcon} />
                  <span>2%</span>{" "} */}
                </div>
                {/* <p className="last24hrs">Last 24 Hours</p> */}
              </div>
            </div>
          </div>
          <div className="maintotalleadscontainer">
            <div className="maintotalsContainers">
              <div className="totalrevenuetitle">
                <div className="maintotalicons">
                  <img src={revenueIcon} />
                </div>
                <h5 className="mt-2">Total Sales (B2B)</h5>
              </div>

              <span
                style={{ cursor: "pointer" }}
                onClick={navigateOrderManagement}
                className="viewdetails"
              >
                {/* <img className="viewimage" src={viewDetailsIcon} /> */}
              </span>
            </div>
            <div className="AmountContaner mt-3">
              <h3 style={{ fontWeight: "600" }} className="total">
                {salesVal || 0}{" "}
              </h3>
              <div>
                <div className="profitContainer">
                  {/* <img src={arrowUpIcon} />
                  <span>2%</span>{" "} */}
                </div>
                {/* <p className="last24hrs">Last 24 Hours</p> */}
              </div>
            </div>
          </div>
          <div className="maintotalleadscontainer">
            <div className="maintotalsContainers">
              <div className="totalrevenuetitle">
                <div className="maintotalicons">
                  <img src={serviceReportIcon} />
                </div>
                <h5 className="mt-2">Total Service (B2C)</h5>
              </div>

              <span className="viewdetails">
                {/* <img onClick={navigateToService} className="viewimage" src={viewDetailsIcon} /> */}
              </span>
            </div>
            <div className="AmountContaner mt-3">
              <h3 style={{ fontWeight: "600" }} className="total">
                {" "}
                ₹{firstRowDetails?.totalServices || 0}{" "}
              </h3>
              <div>
                <div className="profitContainer">
                  {/* <img src={arrowUpIcon} />
                  <span>2%</span>{" "} */}
                </div>
                {/* <p className="last24hrs">Last 24 Hours</p> */}
              </div>
            </div>
          </div>

          <div className="maintotalleadscontainer">
            <div className="maintotalsContainers">
              <div className="totalrevenuetitle">
                <div className="maintotalicons">
                  <img src={inventoryIcon} />
                </div>
                <h5 className="mt-2">Total Variant (B2B)</h5>
              </div>

              <span className="viewdetails">
                {/* <img style={{cursor:"pointer"}} onClick={navigateToVariant} className="viewimage" src={viewDetailsIcon} /> */}
              </span>
            </div>
            <div className="AmountContaner mt-3">
              <h3
                style={{ fontWeight: "600", paddingLeft: "12px" }}
                className="total"
              >
                {" "}
                {firstRowDetails?.totalVariant || 0}{" "}
              </h3>
              <div>
                <div className="profitContainer">
                  {/* <img src={arrowUpIcon} />
                  <span>2%</span>{" "} */}
                </div>
                {/* <p className="last24hrs">Last 24 Hours</p> */}
              </div>
            </div>
          </div>

          {/* <div className="maintotalleadscontainer">
            <div className="maintotalsContainers">
              <div className='totalrevenuetitle'>
                <div className='maintotalicons'>
                  <img src={revenueIcon} />

                </div>
                <h5 className="mt-2">
                  Total Variant
                </h5>
              </div>



              <span className="viewdetails"><img className='viewimage' src={viewDetailsIcon} /></span>
            </div>
            <div className='AmountContaner mt-3'>
              <h3 style={{fontWeight:"600"}} className='total'>{firstRowDetails.totalServices} </h3>
              <div>
                <div className='profitContainer'>
                  <img src={arrowUpIcon} /><span>2%</span> </div>
                <p className='last24hrs'>Last 24 Hours</p>
              </div>


            </div>
          </div> */}
        </div>
        <Container fluid className="fluidcontainer">
          <Row>
            <Col lg={6} className="charts-container">
              {/* <div className="line-chart">
                <LineChart />
              </div>
              <div className="donut-chart">
                <DonutChart />
              </div> */}

              {/* {loading ? ( */}
              {/* <Loader /> */}
              {/* ) : ( */}
              <>
                {/* {LineChartData && */}
                {/* // Object.keys(LineChartData).length > 0 && ( */}
                <AdminAreaChart graphdata={LineChartData} />
                {/* // )} */}
                {/* <div
                  style={{
                    marginTop: "8px",
                    backgroundColor: "#fff",
                    padding: "15px",
                    borderRadius: "30px",
                  }}
                >
                  <AdminDonutChart PieChartData={PieChartData} /> */}
                {/* <img src={salesDonutChart} alt="salesdonutchart" style={{width:"100%"}} /> */}
                {/* </div> */}
              </>
              {/* )} */}
            </Col>
            <Col style={{ padding: "25px" }} lg={6} className="cards-container">
              <div className="totalleadscontainer">
                <div className="headerContainers">
                  <h3
                    style={{ fontWeight: "600" }}
                    className="totalleadsheading"
                  >
                    SALES ORDER
                  </h3>
                  <span className="viewdetails">
                    {/* <img onClick={navigateOrderManagement} className="viewimage" src={viewDetailsIcon} /> */}
                  </span>
                </div>
                <div className="alltotals">
                  <div className="TotalContainers">
                    <h5 className="totalleads">Total</h5>
                    <span
                      style={{ fontWeight: "600", color: "black" }}
                      className="count"
                    >
                      {secondRightRow.total || 0}{" "}
                    </span>
                  </div>
                  <div className="TotalContainers">
                    <h5 className="totalleads"> Pending </h5>
                    <span
                      style={{ fontWeight: "600", color: "black" }}
                      className="count"
                    >
                      {" "}
                      {secondRightRow.totalPending || 0}{" "}
                    </span>
                  </div>
                  <div className="TotalContainers">
                    <h5 className="totalleads"> Done</h5>
                    <span
                      style={{ fontWeight: "600", color: "black" }}
                      className="count"
                    >
                      {" "}
                      {secondRightRow.totalDone || 0}
                    </span>
                  </div>
                  <div className="TotalContainers">
                    <h5 className="totalleads"> Rejected</h5>
                    <span
                      style={{ fontWeight: "600", color: "black" }}
                      className="count"
                    >
                      {" "}
                      {secondRightRow.totalReject || 0}
                    </span>
                  </div>
                </div>
              </div>

              <div className="totalleadscontainer">
                <div className="headerContainers">
                  <h3
                    style={{ fontWeight: "600" }}
                    className="totalleadsheading"
                  >
                    SERVICE JOB CARD (version 6 )
                  </h3>
                  <span className="viewdetails">
                    {/* <img style={{cursor:"pointer"}} onClick={navigateToService} className="viewimage" src={viewDetailsIcon} /> */}
                  </span>
                </div>
                <div className="alltotals">
                  <div className="TotalContainers">
                    <h5 className="totalleads">Total</h5>
                    <span
                      style={{ fontWeight: "600", color: "black" }}
                      className="count"
                    >
                      {" "}
                      {secondRightBoxValue?.total || 0}{" "}
                    </span>
                  </div>
                  <div className="TotalContainers">
                    <h5 className="totalleads"> Done</h5>
                    <span
                      style={{ fontWeight: "600", color: "black" }}
                      className="count"
                    >
                      {" "}
                      {secondRightBoxValue?.totalDone || 0}{" "}
                    </span>
                  </div>
                  <div className="TotalContainers">
                    <h5 className="totalleads"> Pending</h5>
                    <span
                      style={{ fontWeight: "600", color: "black" }}
                      className="count"
                    >
                      {secondRightBoxValue?.totalPending || 0}{" "}
                    </span>
                  </div>
                  <div className="TotalContainers">
                    <h5 className="totalleads"> Rejected</h5>
                    <span
                      style={{ fontWeight: "600", color: "black" }}
                      className="count"
                    >
                      {" "}
                      {secondRightBoxValue?.totalReject || 0}{" "}
                    </span>
                  </div>
                </div>
              </div>
              {/* <div className="totalleadscontainer"> */}
              {/* <p>version 01</p> */}
              {/* <ApexColumnChart serviceChart={serviceChart} />
              </div> */}
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default Dashboard;
